/* eslint-disable */
import i18n from '@/i18n'
import makeCrudModule from '@/lib/uncrudtable/store/crudfactory'
import apiClient from '@/lib/unlogin/store/apiclient'
import { makeGenericStore } from '@/apps/core/store/genericApiViewStore'
import { RESPONSE_LEVEL } from '@/variables'

const modelName = 'NoteLine'
const apiPath = '/note-lines/'
const baseCrud = makeCrudModule(apiClient, modelName, apiPath, 'id')
const genericStore = makeGenericStore(apiClient, apiPath)

const state = {
  ...baseCrud.state
}

const getters = {
  ...baseCrud.getters
}

const actions = {
  ...baseCrud.actions,
  ...genericStore.actions,
  async createNoteLineWithoutNote({commit}, body) {
    const alertMessage = {}
      try {
        let response = await apiClient.post(`${apiPath}create_note_line_without_note/`, body)
        return response.data
      } catch (error) {
        if (error.response.data && error.response.data.level) {
          alertMessage['level'] = error.response.data.level
          alertMessage['message'] = error.response.data.message
        } else {
          alertMessage['level'] = RESPONSE_LEVEL.ERROR
          alertMessage['message'] = i18n.tc('general.errorSomethingHappenedOptional')
        }
        throw alertMessage
      }
  },
  getNotes ({ commit }, note_id) {
    return new Promise(resolve => {
      apiClient.get(`/notes/${note_id}/`).then(res => {
        resolve({ data: [ res.data ] })
      })
    })
  },
  getPromosFilteredByNoteId ({ commit }, note_id) {
    return new Promise((resolve) => {
      apiClient.get(`/promos-for-notes/?note_id=${note_id}`).then(response =>
        resolve({ data: response.data.results}))
    })
  },
  getPromo ({ dispatch }, promo_id) {
    return new Promise((resolve) => {
      apiClient.get(`/promos/${promo_id}/`).then(response => {
        resolve({ data: response.data })
      })
    })
  },
  getNoteFieldChoices ({ dispatch, commit }, obj ) {
    return Promise.all([
      apiClient.get('/note-field-choices/status/')
    ])
      .then(responses => responses.map(response => response.data))
      .catch(() => {
        let error = { message: i18n.tc('general.errorSomethingHappenedOptional') }
        throw error
      })
  }
}

const mutations = {
  ...baseCrud.mutations
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
